import { useRef, useState } from "react";
import { Alert, Button, Col, Form, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// import { getCaseId, getClientId } from "../../Utils/helper";
import { api_without_cancellation } from "../../api/api";
import makeDeposit from "../SettlementDashboard/api/makeDeposit";
import UserChatBubble from "../Forms/FirmUserBtn";
import {
  formatCalendarDate,
  inputCurrencyFormat2,
  setCaseId,
  setClientId,
} from "../../Utils/helper";
import { setBlurEffect } from "../../Redux/header_blur/action";
import { setHeaderName } from "../../Redux/header_name/action";

function formatDateFromString(dateString) {
  return formatCalendarDate(dateString);
}
function formatDateFromString2(dateString) {
  if (!dateString) return "";

  if (typeof dateString === "string") {
    // Preserve the calendar date and year without timezone or 1900-based conversions.
    const isoDate = dateString.match(/^\d{4,}-\d{2}-\d{2}(?=$|T|\s)/)?.[0];
    if (isoDate) return isoDate;

    const usDate = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4,})$/);
    if (usDate) {
      const [, month, day, year] = usDate;
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }

  const dateObject = new Date(dateString);
  if (Number.isNaN(dateObject.getTime())) return "";

  const year = String(dateObject.getFullYear()).padStart(4, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const day = String(dateObject.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function formatDateFromString3(dateString) {
  const date = formatDateFromString2(dateString);
  if (!date) return "";

  const [year, month, day] = date.split("-");
  return `${month}/${day}/${year}`;
}
// function convertToHtmlDateInputValue(isoDateString) {
//   // Attempt to parse the date string
//   const date = new Date(isoDateString);

//   // Check if the date is invalid
//   if (isNaN(date.getTime())) {
//     throw new Error("Invalid date format");
//   }

//   // Convert the date to the local time zone and format it as YYYY-MM-DD
//   const year = date.getFullYear();
//   // GetMonth() returns 0-11; adding 1 to get 1-12. Use padStart to ensure two digits.
//   const month = (date.getMonth() + 1).toString().padStart(2, "0");
//   // GetDate() returns 1-31; Use padStart to ensure two digits.
//   const day = date.getDate().toString().padStart(2, "0");

//   // Construct the YYYY-MM-DD format
//   return `${year}-${month}-${day}`;
// }

const EditCheckModal = ({ isVisible, onHide, check, fetchAccountsData, caseData, _panel }) => {
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpeningCase, setIsOpeningCase] = useState(false);
  const caseSwitchPendingRef = useRef(false);
  const linkedCase = check?.for_case?.id ? check.for_case : caseData;
  const linkedCaseId = linkedCase?.id;
  const linkedClientId = linkedCase?.for_client?.id;

  const handleGoToCase = async () => {
    if (!linkedClientId || !linkedCaseId || caseSwitchPendingRef.current) return;

    caseSwitchPendingRef.current = true;
    setIsOpeningCase(true);

    try {
      await api_without_cancellation.get(`/api/switch_client/${linkedClientId}/${linkedCaseId}/1/`);
      setClientId(linkedClientId);
      setCaseId(linkedCaseId);
      dispatch(setBlurEffect(false));
      dispatch(setHeaderName("Case"));
      onHide();
      navigate(`/bp-client/${linkedClientId}/${linkedCaseId}`, {
        replace: true,
        state: { openingCase: linkedCase },
      });
    } catch (error) {
      console.error("Unable to open the check's case:", error);
    } finally {
      caseSwitchPendingRef.current = false;
      setIsOpeningCase(false);
    }
  };

  // const [errors, setErrors] = useState(false);
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const errors = false;
  const handleDelete = async () => {
    try {
      // const response = await api_without_cancellation.get(
      //   origin +
      //   `/api/documents/get-courtforms/?client_id=${getClientId()}&case_id=${getCaseId()}`
      // );
      const response = await api_without_cancellation.delete(
        origin + `/api/accounting-page/edit-check/?check_id=${check?.id}`
      );
      if (response.status === 200) {
        fetchAccountsData();
        onHide();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const formik = useFormik({
    initialValues: {
      ...check,
      cheque_date: formatDateFromString2(check?.cheque_date),
      check_cleared: formatDateFromString2(check?.cleared_date),
      check_sent: formatDateFromString2(check?.sent_date),
    },
    // validationSchema: accountsValidationSchema,
    onSubmit: async () => {
      const payload = {
        check_id: check.id, // Assuming check object has an id field
        date_requested: formatDateFromString(formik.values.date_requested), // The selected date for requested date
        due_date: formatDateFromString(formik.values.due_date), // The selected date for due date
        payee: formik.values.payee, // The payee name or information
        amount: formik.values.amount, // The amount in the check
        memo: formik.values.memo, // Memo or description for the check
        cheque_date: formatDateFromString3(formik.values.cheque_date), // The date of the check
        cheque_number: formik.values.cheque_number, // Check number or invoice number
        // date_cleared: formatDateFromString(
        //   panel === "trust_ledger" ? formik.values.cleared_date : formik.values.clearedDate
        // ),
        sent_date: formatDateFromString3(formik.values.check_sent),
        date_cleared: formatDateFromString3(formik.values.check_cleared),
      };

      try {
        const response = await api_without_cancellation.post(
          "/api/accounting-page/edit-check/",
          payload
        );
        if (response.status === 200) {
          fetchAccountsData();
          onHide();
        }
      } catch (error) {
        console.error(error);
      }
      // const payload = {
      //   ...values,
      //   amount: parseFloat(values.amount), // Ensure amount is a float if backend expects a number
      // };
      // const url = isEdit
      //   ? `api/edit-cost/${cost.id}/`
      //   : `api/add-cost/${clientId}/${caseId}/`;
      // try {
      //   await api.post(url, payload);
      //   toggleTriggerUpdate(); // Refresh any necessary data
      //   formik.resetForm(); // Clear the form after successful submission
      //   onHide(); // Close the modal
      // } catch (error) {
      //   console.error(
      //     "Error adding cost:",
      //     error.response ? error.response.data : error.message
      //   );
      //   setErrors(true);
      // }
    },
    enableReinitialize: true,
  });

  const [markedDeposit, setMarkedDeposit] = useState(check?.deposit);
  const [previousAmount, setPreviousAmount] = useState("");
  const [amountFocused, setAmountFocused] = useState(false);
  return (
    // <Modal show={isVisible} onHide={onHide} centered size={isEdit ? 'md' : 'lg'}>
    <Modal
      show={isVisible}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-insurance-dialog justify-content-center "
    >
      <div>
        <div className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center modal-header">
          <div
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center modal-title h4"
            id="modal_title"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Edit Check
          </div>
        </div>
        <Modal.Body style={{ width: "100%", background: "white", padding: "5px" }}>
          {errors ? <Alert variant="danger">Error editing a check record.</Alert> : <></>}
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="m-b-5  d-flex align-items-center">
              <Form.Label
                className="text-nowrap height-25 p-t-0 p-b-0 d-flex align-items-center text-grey"
                column
                sm={2}
              >
                Requested:
              </Form.Label>
              <Col sm={4} style={{ display: "flex", alignItems: "center" }}>
                {/* <Form.Control
                  type="date"
                  name="date"
                  {...formik.getFieldProps("date")}
                />
                {formik.touched.date && formik.errors.date && (
                  <div className="text-danger">{formik.errors.date}</div>
                )} */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* <div
                    className="icon-container"
                    style={{
                      display: "flex",
                      height: "19px",
                      width: "19px",
                      marginRight: "4px",
                    }}
                  >
                    <i className="height-i-25 ic ic-client-avatar" />
                    <div className="border-overlay" />
                  </div>
                  {check?.check_requested_by?.first_name && check?.check_requested_by?.last_name
                    ? `${check.check_requested_by.first_name} ${check.check_requested_by.last_name}`
                    : "Christian Ross"}
                </div> */}
                  <UserChatBubble
                    userId={check.check_requested_by?.id}
                    first_name={check.check_requested_by.first_name ?? ""}
                    last_name={check.check_requested_by.last_name ?? ""}
                    profilePic={check.check_requested_by.profile_pic ?? ""}
                    is_active={check.check_requested_by?.is_active}
                    width={21}
                    hideIcon={true}
                    isActive={userOnlineStatus?.[check.check_requested_by.id]?.isOnline ?? false}
                  />
                </div>
              </Col>
              <Form.Label
                style={{ display: "flex", alignItems: "center" }}
                className="text-nowrap height-25 m-l-5 p-t-0 p-b-0 text-grey"
                column
                sm={2}
              >
                Date Requested:
              </Form.Label>
              <Col style={{ display: "flex", alignItems: "center" }} sm={4}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  {formatDateFromString(check?.date_requested)}
                </p>
              </Col>
            </Form.Group>

            <Form.Group className="m-b-5 d-flex align-items-center">
              {/* <Form.Label className="text-nowrap" column sm={2}> */}
              <Form.Label column sm={2} className="p-t-0 p-b-0 text-grey">
                Amount:
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="text"
                  inputMode="decimal"
                  name="amount"
                  className="form-control height-25 rounded-0 p-t-0 p-b-0"
                  value={
                    amountFocused
                      ? `$ ${formik.values.amount ?? ""}`
                      : formik.values.amount !== "" && formik.values.amount !== null
                        ? inputCurrencyFormat2(formik.values.amount)
                        : ""
                  }
                  onFocus={() => {
                    setPreviousAmount(formik.values.amount);
                    formik.setFieldValue("amount", "");
                    setAmountFocused(true);
                  }}
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^0-9.]/g, "");

                    if ((value.match(/\./g) || []).length > 1) {
                      value = value.substring(0, value.lastIndexOf("."));
                    }

                    if (value.includes(".")) {
                      const parts = value.split(".");
                      if (parts[1].length > 4) {
                        parts[1] = parts[1].substring(0, 4);
                      }
                      value = parts.join(".");
                    }

                    formik.setFieldValue("amount", value);
                  }}
                  onBlur={() => {
                    setAmountFocused(false);

                    if (!formik.values.amount) {
                      formik.setFieldValue("amount", previousAmount);
                    }

                    formik.setFieldTouched("amount", true);
                  }}
                  isInvalid={!!formik.errors.amount && formik.touched.amount}
                />
                {/* <Form.Control
                  type="number"
                  name="amount"
                  className="form-control height-25 rounded-0 p-t-0 p-b-0"
                  onChange={formik.handleChange}
                  {...formik.getFieldProps("amount")}
                  isInvalid={!!formik.errors.amount && formik.touched.amount}
                /> */}
                <Form.Control.Feedback type="invalid">{formik.errors.amount}</Form.Control.Feedback>
              </Col>

              <Form.Label
                className="text-nowrap height-21 m-l-5 p-b-0 p-t-0 text-grey"
                column
                sm={2}
              >
                Date Due:
              </Form.Label>
              <Col style={{ display: "flex", alignItems: "center" }} sm={4}>
                <p>{formatDateFromString(check?.due_date)}</p>
              </Col>
            </Form.Group>

            <Form.Group className="m-b-5 d-flex">
              <Form.Label column sm={2} className="p-t-0 p-b-0 d-flex align-items-center text-grey">
                Payee:
              </Form.Label>
              <Col sm={10} className="">
                <Form.Control
                  type="text"
                  name="payee"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  {...formik.getFieldProps("payee")}
                />
                {formik.touched.payee && formik.errors.payee && (
                  <div className="text-danger">{formik.errors.payee}</div>
                )}
              </Col>
            </Form.Group>

            <Form.Group className="m-b-5 d-flex">
              <Form.Label column sm={2} className="p-t-0 p-b-0 d-flex align-items-center text-grey">
                Memo:
              </Form.Label>
              <Col sm={10} className="">
                <Form.Control
                  type="text"
                  name="memo"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  {...formik.getFieldProps("memo")}
                />
              </Col>
            </Form.Group>

            <Form.Group className="m-b-5 d-flex">
              <Form.Label
                className="text-nowrap d-flex align-items-center p-t-0 p-b-0 text-grey"
                column
                sm={2}
              >
                Check Date:
              </Form.Label>
              <Col sm={4} className="">
                <Form.Control
                  type="date"
                  name="cheque_date"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  style={{ appearance: "none" }}
                  value={formik.values.cheque_date || ""}
                />
                {formik.touched.date && formik.errors.date && (
                  <div className="text-danger">{formik.errors.date}</div>
                )}
              </Col>

              <Form.Label
                column
                sm={2}
                className="p-t-0 m-l-5 d-flex align-items-center p-b-0 text-grey m-r-5"
              >
                Check #:
              </Form.Label>
              <Col className="">
                <Form.Control
                  type="text"
                  name="cheque_number"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  {...formik.getFieldProps("cheque_number")}
                />
                {formik.touched.invoice_number && formik.errors.invoice_number && (
                  <div className="text-danger">{formik.errors.invoice_number}</div>
                )}
              </Col>
            </Form.Group>
            <Form.Group className="m-b-5 d-flex">
              <Form.Label
                className="text-nowrap d-flex align-items-center p-t-0 p-b-0 text-grey"
                column
                sm={2}
              >
                Sent Date:
              </Form.Label>
              <Col sm={4}>
                <Form.Control
                  type="date"
                  name="check_sent"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  style={{ appearance: "none" }}
                  value={formik.values.check_sent || ""}
                />
              </Col>

              <Form.Label
                className="text-nowrap p-t-0 d-flex align-items-center m-l-5 m-r-5 p-b-0 text-grey"
                column
                sm={2}
              >
                Cleared Date:
              </Form.Label>
              <Col>
                <Form.Control
                  type="date"
                  name="check_cleared"
                  className="form-control height-25 p-t-0 p-b-0 rounded-0"
                  onChange={formik.handleChange}
                  style={{ appearance: "none" }}
                  value={formik.values.check_cleared || ""}
                />
              </Col>
            </Form.Group>

            <Form.Group className="m-b-5 d-flex align-items-center gap-1">
              <Form.Label column sm={2} className="p-t-0 p-b-0 whitespace-nowrap text-grey">
                Mark Deposit:
              </Form.Label>
              <Col sm={4} className="d-flex align-items-center">
                <input
                  type="checkbox"
                  name="mark_deposit"
                  checked={markedDeposit}
                  onChange={(e) => {
                    const newVal = e.target.checked;
                    const payload = {
                      check_id: check?.id,
                      mark_deposit: newVal ? "True" : "False",
                    };
                    setMarkedDeposit(newVal);
                    makeDeposit(payload);
                    fetchAccountsData();
                  }}
                />
              </Col>
            </Form.Group>

            <Button
              variant="primary"
              type="button"
              className="w-100 height-25 m-b-5 d-flex align-items-center justify-content-center"
              onClick={handleGoToCase}
              disabled={isOpeningCase || !linkedClientId || !linkedCaseId}
            >
              {isOpeningCase ? "Opening Case…" : "Go to Case"}
            </Button>

            <div className="d-flex justify-content-between m-t-5 p-0">
              <Button
                className="height-25 d-flex align-items-center justify-content-center"
                variant="secondary"
                onClick={() => {
                  onHide();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="height-25"
                style={{ padding: "0px 12px" }}
                onClick={handleDelete}
              >
                Delete
              </Button>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  // ...(!isEdit && { width: "100%" }),
                }}
              >
                <Button
                  variant="success"
                  className="m-l-5 bg-success height-25"
                  style={{ padding: "0px 12px" }}
                  type="submit"
                >
                  Save and Close
                </Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default EditCheckModal;
